(function () {
  "use strict";

  if (window.__eddBooted) { window.__eddBoot && window.__eddBoot(); return; }
  window.__eddBooted = true;

  /* ---------- Constants ---------- */
  var IST_OFFSET_MIN = 330;
  var MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
  var DAYS   = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
  var EDD_ENDPOINT    = "https://myopgoswiftedd.lovable.app/api/public/edd";
  var EDD_PUBLIC_KEY  = "847jF9tWvDhbhpjX0vRmmNUC9";
  var DEFAULT_SRC_PIN = 560117;
  function istNow() {
    var n = new Date();
    return new Date(n.getTime() + n.getTimezoneOffset() * 60000 + IST_OFFSET_MIN * 60000);
  }

  function minutesOfDay(d) {
    return d.getHours() * 60 + d.getMinutes();
  }

  function msUntilCutoff(ist, c) {
    var x = new Date(ist);
    x.setHours(Math.floor(c / 60), c % 60, 0, 0);
    return x - ist;
  }

  function fmtCountdown(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    var h = Math.floor(s / 3600); s -= h * 3600;
    var m = Math.floor(s / 60);   s -= m * 60;
    if (h > 0) return h + "h " + m + "m";
    if (m > 0) return m + "m " + s + "s";
    return s + "s";
  }

  function fmtDate(d, withDay) {
    var base = d.getDate() + " " + MONTHS[d.getMonth()];
    return withDay ? DAYS[d.getDay()] + ", " + base : base;
  }

  function fmtDates(a, b, fmt) {
    if (fmt === "single") return fmtDate(a, true);
    if (a.getDate() === b.getDate() && a.getMonth() === b.getMonth()) return fmtDate(a, false);
    return fmtDate(a, false) + " \u2013 " + fmtDate(b, false);
  }
  function pickEdd(d) {
    if (!d) return null;
    var e = d.edd
         || (d.result && (d.result.edd || d.result))
         || d.data
         || d;
    if (!e) return null;
    var min = (e.min != null) ? e.min : e.minDays;
    var max = (e.max != null) ? e.max : e.maxDays;

    if (min == null) return null;  
    if (max == null) max = min;     

    return { min: min, max: max };
  }
  function getEDD(pincode, cfg) {
    var srcPin   = (cfg && !isNaN(cfg.srcPin)) ? cfg.srcPin : DEFAULT_SRC_PIN;
    var endpoint = (cfg && cfg.endpoint) ? cfg.endpoint : EDD_ENDPOINT;
    var apiKey   = (cfg && cfg.apiKey)   ? cfg.apiKey   : EDD_PUBLIC_KEY;

    var url = endpoint
      + "?publickey=" + encodeURIComponent(apiKey)
      + "&srcPin="    + encodeURIComponent(srcPin)
      + "&destPin="   + encodeURIComponent(pincode);

    return fetch(url, { method: "GET", headers: { "Accept": "application/json" } })
      .then(function (r) {
        if (!r.ok) throw new Error("HTTP " + r.status);   // 401/403/500 → .catch() in load()
        return r.json();
      })
      .then(function (d) {

        var edd = pickEdd(d);
        if (!edd) {
          return null;                                   
        }

        var start = new Date();
        start.setDate(start.getDate() + Number(edd.min) + cfg.processing + 0);

        var end = new Date();
        end.setDate(end.getDate() + Number(edd.max) + cfg.processing + 0);
        return { start: start, end: end };
      });
  }

  /* ---------- Per-widget initialisation ---------- */
  function initWidget(root) {
    if (root.dataset.eddReady) return;
    root.dataset.eddReady = "1";

     var cfg = {
      proxy:      root.dataset.proxy,
      srcPin:     parseInt(root.dataset.srcpin, 10),
      processing: parseInt(root.dataset.processing, 10) || 0,
      endpoint:   root.dataset.endpoint,
      apiKey:     root.dataset.apikey
    };
    var cutoffMin = parseInt(root.dataset.cutoff, 10) || 750;
    var openMin   = parseInt(root.dataset.open,   10) || 390;
    var dateFmt   = "range";

    var pin   = root.querySelector(".edd__pin-input");
    var check = root.querySelector(".edd__check");
    var err   = root.querySelector(".edd__err");
    var row   = root.querySelector(".edd__row--edd");
    var txt   = root.querySelector(".edd__date");
    var edd = null, ticker = null;
    function showErr(msg) { err.textContent = msg; err.classList.add("is-on"); }
    function hideErr()    { err.classList.remove("is-on"); err.textContent = ""; }
    function renderText() {
      if (!edd) return;
      var ist   = istNow();
      var mins  = minutesOfDay(ist);
      var dates = fmtDates(edd.start, edd.end, dateFmt);

      if (mins >= openMin && mins <= cutoffMin) {
        txt.innerHTML = 'Order in <span class="edd__hl">'
          + fmtCountdown(msUntilCutoff(ist, cutoffMin))
          + '</span> \u2014 get it <span class="edd__hl">' + dates + '</span>';
      } else {
        txt.innerHTML = 'Order Now \u2014 get it by <span class="edd__hl">' + dates + '</span>';
      }
    }

    function stopTicker() { if (ticker) { clearInterval(ticker); ticker = null; } }
    function startTicker() { stopTicker(); renderText(); ticker = setInterval(renderText, 1000); }

    /* ---- Fetch & display EDD ---- */
    function load(pincode) {
      row.classList.add("is-on");
      txt.innerHTML = '<span class="edd__loading">Checking delivery\u2026</span>';
      check.disabled = true;
      var oldLabel = check.textContent;
      check.textContent = "\u2026";

      getEDD(pincode, cfg)
        .then(function (r) {
          check.disabled = false;
          check.textContent = oldLabel;

          if (!r) {
            stopTicker();
            row.classList.remove("is-on");
            showErr("Delivery service unavailable for this pincode.");
            return;
          }
          edd = r;
          startTicker();
        })
        .catch(function () {
          check.disabled = false;
          check.textContent = oldLabel;
          stopTicker();
          row.classList.remove("is-on");
          showErr("Delivery service unavailable for this pincode.");
        });
    }
    function onCheck() {
      var v = pin.value.trim();
      if (!/^\d{6}$/.test(v)) { showErr("Please enter a valid 6-digit pincode."); return; }
      hideErr();
      load(v);
    }
    pin.addEventListener("input", function () {
      pin.value = pin.value.replace(/[^0-9]/g, "");
      hideErr();
    });
    check.addEventListener("click", onCheck);
    pin.addEventListener("keydown", function (e) { if (e.key === "Enter") onCheck(); });

    // Auto-check if a prefilled pincode is valid
    if (/^\d{6}$/.test(pin.value.trim())) onCheck();
  }

  /* ---------- Boot: find all widgets on the page ---------- */
  function boot() {
    var widgets = document.querySelectorAll(".edd");
    for (var i = 0; i < widgets.length; i++) initWidget(widgets[i]);
  }

  window.__eddBoot = boot;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  // Re-boot when a Shopify section is reloaded in the theme editor
  document.addEventListener("shopify:section:load", boot);
})();
